import { Injectable } from '@angular/core';
import { ClaimService } from '../claim/claim.service';
import {
    GetConfigurationSummaryRequest,
    GetConfigurationSummaryResponse,
    GetConfigurationSummaryService
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/buyer-account/get-configuration-summary';
import { ReplaySubject } from 'rxjs';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';

// todo: this should be moved out of common-ui library
@Injectable({ providedIn: 'root' })
export class GetPayLaterProgramService {
    private _isPayLaterEnabledSubject = new ReplaySubject<boolean>(1);
    public isPayLaterEnabled$ = this._isPayLaterEnabledSubject.asObservable();

    constructor(
        private _claimService: ClaimService,
        private _getConfigurationSummary: GetConfigurationSummaryService,
        public userService: UserService
    ) {
        SingletonServiceGuard.register('GetPayLaterProgramService');
        this._getConfigurationSummary.dataStream.subscribe(
            (config: GetConfigurationSummaryResponse) => {
                this._isPayLaterEnabledSubject.next(
                    config.isPayLaterEnabled || (config as any).isPayLaterEnabled
                );
            }
        );

        this.userService.user$.subscribe((user) => {
            if (
                !!user &&
                (this._claimService.isOnSync(DashboardClaim.FinancingBuyerPortal) ||
                    this._claimService.isOnSync(DashboardClaim.FinancingAccountPortal))
            ) {
                this._getConfigurationSummary.execute(new GetConfigurationSummaryRequest());
            }
        });
    }
}
